<template>
  <v-application v-if="access.setting_general">
    <v-settings>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("general_settings") }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-text-field :label="$t('email')" v-model="user.email" />
        <v-text-field
          :label="$t('bussiness_name')"
          v-model="user.organization_name"
        />
        <!-- <v-combobox
          :label="$t('UI_language')"
          v-model="user.ui_language"
          v-bind:items="langs"
        /> -->
      </v-card-text>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("features") }}</v-toolbar-title>
      </v-toolbar>
      <v-list two-line>
        <v-list-item
          v-for="(_feature, feature_index) in features"
          v-bind:key="feature_index"
        >
          <v-list-item-avatar
            @click="feature[_feature.name] = !feature[_feature.name]"
            class="noselect"
          >
            <v-icon>{{ _feature.icon }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content
            @click="feature[_feature.name] = !feature[_feature.name]"
            class="noselect"
          >
            <v-list-item-title>{{ $t(_feature.title) }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ $t(_feature.description) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch v-model="feature[_feature.name]" />
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <template #actions>
        <v-btn
          text
          v-on:click="
            () => {
              cancel_feature();
              cancel_user();
            }
          "
        >
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          text
          color="primary"
          :loading="loading_settings_feature || loading_settings_user"
          v-on:click="
            () => {
              loading_settings_feature = true;
              loading_settings_user = true;
              save_feature();
              save_user();
            }
          "
        >
          {{ $t("save") }}
        </v-btn>
      </template>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Langable from "../../mixins/langable";
import Features from "../../mixins/features";
import Userable from "../../mixins/userable";

export default {
  name: "SettingsGeneral",
  mixins: [Langable, Features, Userable],
  data: () => ({
    loading_settings_feature: false,
    loading_settings_user: false,
  }),
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>

<style>
.noselect {
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
